<template>
  <v-snackbar v-model="display" elevation="24" color="error">
    {{ exception.message }}

    <template v-slot:action="{ attrs }">
      <v-btn color="white" icon v-bind="attrs" @click="display = false"><v-icon>mdi-close</v-icon></v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data: () => ({
    display: false,
  }),
  computed: {
    ...mapGetters({
      exception: 'exception/exception',
    }),
  },
  watch: {
    exception: {
      handler() {
        this.display = false
        this.display = true
      },
      deep: true,
    },
  },
}
</script>
